import { ui } from '!/skin'
import { Skeleton } from '@/ui/components/Skeleton'
import type { JSX } from 'react'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title(): JSX.Element {
  return <AppTitle>Logout</AppTitle>
}

LogoutPage.displayName = 'LogoutPage'
export function LogoutPage(): JSX.Element {
  return (
    <ui.PageWrapper>
      <Skeleton pageType='main' isLoading={true}>
        <></>
      </Skeleton>
    </ui.PageWrapper>
  )
}
